import React, { useState } from 'react';
import api from '../utils/api';
import { showToast } from './ToastNotifications';

// Modal ganti password yang dipakai bersama oleh Mentor & Mahasiswa/PO
// (dan bisa dipakai role lain nanti) — backend-nya satu endpoint generik
// PUT /users/change-password, wajib password lama untuk verifikasi.
const ChangePasswordModal = ({ show, onClose }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!show) return null;

  const resetForm = () => {
    setOldPassword('');
    setNewPassword('');
    setConfirmPassword('');
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword.length < 6) {
      showToast('Password baru minimal 6 karakter.', 'warning');
      return;
    }
    if (newPassword !== confirmPassword) {
      showToast('Konfirmasi password baru tidak cocok.', 'warning');
      return;
    }

    setIsSubmitting(true);
    try {
      await api.changePassword({ oldPassword, newPassword });
      showToast('Password berhasil diubah.', 'success');
      handleClose();
    } catch (error) {
      showToast(error.message || 'Gagal mengubah password.', 'danger');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div
        className='modal fade show d-block'
        tabIndex='-1'
        role='dialog'
      >
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content border-0 rounded-4 shadow'>
            <form onSubmit={handleSubmit}>
              <div className='modal-header border-0 pb-0'>
                <h5 className='modal-title fw-bold text-dark'>
                  <i className='bi bi-shield-lock-fill text-primary me-2'></i>
                  Ubah Password
                </h5>
                <button
                  type='button'
                  className='btn-close'
                  onClick={handleClose}
                  disabled={isSubmitting}
                ></button>
              </div>
              <div className='modal-body'>
                <div className='mb-3'>
                  <label className='small text-muted fw-semibold d-block mb-1'>Password Lama</label>
                  <input
                    type='password'
                    className='form-control rounded-3'
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    required
                    autoFocus
                  />
                </div>
                <div className='mb-3'>
                  <label className='small text-muted fw-semibold d-block mb-1'>Password Baru</label>
                  <input
                    type='password'
                    className='form-control rounded-3'
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    minLength={6}
                    required
                  />
                  <span className='text-muted extra-small'>Minimal 6 karakter.</span>
                </div>
                <div>
                  <label className='small text-muted fw-semibold d-block mb-1'>Konfirmasi Password Baru</label>
                  <input
                    type='password'
                    className='form-control rounded-3'
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    minLength={6}
                    required
                  />
                </div>
              </div>
              <div className='modal-footer border-0 pt-0'>
                <button
                  type='button'
                  className='btn btn-light rounded-pill px-4 fw-bold'
                  onClick={handleClose}
                  disabled={isSubmitting}
                >
                  Batal
                </button>
                <button
                  type='submit'
                  className='btn btn-primary rounded-pill px-4 fw-bold shadow-sm'
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <span className='spinner-border spinner-border-sm me-2' role='status'></span>
                  ) : (
                    <i className='bi bi-check-lg me-1'></i>
                  )}
                  Simpan
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  );
};

export default ChangePasswordModal;
